import { useIntl } from 'react-intl'
import { Grid } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'

function MapsCounter({ mapsCount }: { mapsCount: number | undefined }) {
  const intl = useIntl()

  if (mapsCount === null || mapsCount === undefined) return null

  return (
    <Grid item xs={12} pt={2}>
      <Typography variant="caption" color="textSecondary">
        {intl.formatMessage({ id: 'maps.filters.total' }, { itemCount: mapsCount })}
      </Typography>
    </Grid>
  )
}

export default MapsCounter
